import React from 'react'
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg'
import {
  CardNavLink,
  NFTCardImage,
  NFTCardMeta,
  NFTCardPrice,
  NFTCardTitle,
  NFTCardView,
  CardImageNavLink,
  NFTCardImageOverlay
} from '../../components/NFTCard/syled'
import { IBaseCard } from '../../components/NFTCard/INFTCard'
import { useGetSaleTokenItem, useGetNFTPrice } from '../../../../hooks/useNFTMarketPlace'
import NFTPriceSymbol from '../../components/NFTPriceSymbol'
import { ReactComponent as ForkIcon } from '../../../../assets/svg/git-fork.svg'
import { ReactComponent as AlertIcon } from '../../../../assets/svg/alert.svg'
import { useGetCreators } from '../../../../hooks/useYetiSwapNFTCollection'
import NFTUserInfoCompact from '../../components/NFTUserInfoCompact'
import { CardMeta, CardContainer, CardImage, CardTitle, CardCollection, CardPrice, CardButtons, CardText, CardLikeCount } from '../../newComponents/NFTCard/styled'
import { YTS } from '../../../../constants'
import { useActiveWeb3React } from '../../../../hooks'
import NFTCardButtons from '../../nftFormats/Default/components/NFTCardButtons/NFTCardButtons'
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useNFTLike from '../../data/useNFTLike'
import cx from '../../../../utils/cx'
import { useHistory } from 'react-router-dom'

export default function BaseCard(props: IBaseCard) {
  const {
    token,
    tokenId,
    collection,
    detailUrl,
    setSale,
    transferNFT,
    approve,
    buyNow,
    isSale,
    isWallet,
    removeSale,
    approveState,
    //  account,
    saleToken,
    owner,
    tokenName,
    children,
    priceInfo,
    customStyleCardImage,
    stakeToggle,
    stakeState,
    isStake
  } = props
  const { chainId } = useActiveWeb3React()
  const navigator = useHistory();
  const tokenCreator = useGetCreators(tokenId);
  const { action, isLiked, likeCount, actionTitle } = useNFTLike(collection.tokenAddress.toLowerCase(), tokenId);

  const yts = chainId !== undefined ? YTS[chainId] : undefined
  const NFTTokenPrice: string = useGetNFTPrice(token?.price, yts, true)
  const saleTokenItem = useGetSaleTokenItem(saleToken)
  let fiatPrice: number | null = null

  if (priceInfo && token && token.price) {
    if (saleTokenItem.symbol === 'YTS') {
      fiatPrice = parseFloat(NFTTokenPrice) * priceInfo.usdPrice
    } else {
      fiatPrice = parseFloat(NFTTokenPrice) * priceInfo.avaxUsdPrice
    }
  }

  const tokenLink = `${detailUrl}/${collection.tokenAddress}/${tokenId}`

  const onClickCollection = () => {
    navigator.push(`/collection/${collection.tokenAddress}`);
  }

  return (
    <CardContainer>
      {!props.noButtons &&
        <CardLikeCount className={cx({ liked: isLiked })} title={actionTitle} onClick={action}>
          <FontAwesomeIcon icon={faHeart} size={"1x"} />
          {likeCount > 0 && <span>{likeCount}</span>}
        </CardLikeCount>
      }
      <CardImageNavLink className="link" to={tokenLink}>
        <CardImage style={customStyleCardImage}>
          {children}
        </CardImage>
      </CardImageNavLink>
      <CardTitle title={tokenName}>
        {tokenName}
      </CardTitle>
      {collection?.tokenAddress.toLowerCase() !== '0xc01b3e9678c73A96BA51d040ce435d1c28fd1E1d'.toLowerCase() ? <CardCollection title='Verified Collection'>
        {collection.forkProject && (
          <ForkIcon width="0.9rem" height="0.9rem" className="form-icon" title="Forked Collection" />
        )}
        {collection.oldProject && (
          <AlertIcon width="0.9rem" height="0.9rem" className="form-icon" title="Old Project, You need to migrate new version" />
        )}
        <VerifiedIcon width="1rem" />
        <CardText onClick={onClickCollection}>{collection.name}</CardText>
      </CardCollection>
        :
        tokenCreator && <div style={{ width: '100%' }}><NFTUserInfoCompact accountAddress={tokenCreator} currentAccountAdress={null} label='Creator' redirectToLink='/profile/{{address}}?tab=on-sale' /></div>
      }
      <CardMeta>
        {token?.seller && <NFTUserInfoCompact accountAddress={token?.seller} currentAccountAdress={null} label='Seller' redirectToLink='/profile/{{address}}?tab=on-sale' />}
        {isSale ? (
          <CardPrice>
            <span>Price</span>
            <div>
              {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
            </div>
            {fiatPrice && <div>~{fiatPrice.toFixed(2)} USD</div>}
          </CardPrice>
        ) : (
          props.noButtons ? '' : 'Not For Sale'
        )}
      </CardMeta>
      <CardButtons>
        <NFTCardButtons
          tokenContractAddress={collection.tokenAddress}
          tokenId={tokenId}
          isWallet={isWallet}
          token={token}
          setSale={setSale}
          approve={approve}
          buyNow={buyNow}
          isSale={isSale}
          tokenName={tokenName}
          removeSale={removeSale}
          transferNFT={transferNFT}
          approveState={approveState}
          noButtons={props.noButtons}
          saleToken={saleToken}
          owner={owner}
          priceInfo={priceInfo}
          stakeToggle={stakeToggle}
          stakeState={stakeState}
          isStake={isStake}
        />
      </CardButtons>
    </CardContainer>
  )

  // return (
  //   <NFTCardView className="nft-card-view2">
  //     <NFTCardImage className="nft-card-image" style={customStyleCardImage}>
  //       <CardImageNavLink className="link" to={tokenLink}>
  //         {children}
  //         <NFTCardImageOverlay className="image-overlay">Details</NFTCardImageOverlay>
  //       </CardImageNavLink>
  //     </NFTCardImage>
  //     <NFTCardMeta>
  //       <CardNavLink to={tokenLink}>
  //         {collection.tokenAddress !== '0xc01b3e9678c73A96BA51d040ce435d1c28fd1E1d' ? (
  //           <div className="CollectionAddress" title={`${collection.name} Verified Collection`}>
  //             {collection.forkProject && (
  //               <ForkIcon width="0.9rem" height="0.9rem" className="form-icon" title="Forked Collection" />
  //             )}
  //             {collection.oldProject && (
  //               <AlertIcon width="0.9rem" height="0.9rem" className="form-icon" title="Old Project, You need to migrate new version" />
  //             )}
  //             <VerifiedIcon width="1rem" /> {collection.name}
  //           </div>
  //         ) : (
  //           tokenCreator ?
  //             <div className="CollectionAddress">
  //               Creator{" : "}<NFTUserInfoCompact accountAddress={tokenCreator} currentAccountAdress={null} />
  //             </div>
  //             :
  //             <div className="collectionPlaceHolder" />
  //         )}

  //         <NFTCardTitle title={tokenName}>{tokenName}</NFTCardTitle>
  //         {isSale ? (
  //           <NFTCardPrice>
  //             <div className="tokenPrice">
  //               {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
  //             </div>
  //             {fiatPrice && <div className="fiat-price">(${fiatPrice?.toFixed(2)})</div>}
  //           </NFTCardPrice>
  //         ) : (
  //           'Not For Sale'
  //         )}
  //       </CardNavLink>
  //     </NFTCardMeta>
  //     <NFTCardButtons
  //       tokenContractAddress={collection.tokenAddress}
  //       tokenId={tokenId}
  //       isWallet={isWallet}
  //       token={token}
  //       setSale={setSale}
  //       approve={approve}
  //       buyNow={buyNow}
  //       isSale={isSale}
  //       tokenName={tokenName}
  //       removeSale={removeSale}
  //       transferNFT={transferNFT}
  //       approveState={approveState}
  //     //  account={account}
  //       saleToken={saleToken}
  //       owner={owner}
  //       priceInfo={priceInfo}
  //       stakeToggle={stakeToggle}
  //       stakeState={stakeState}
  //       isStake={isStake}
  //     />
  //   </NFTCardView>
  // )
}
